import { lazy, Suspense } from "react";

/**
 * Las herramientas de TanStack Query, solo en desarrollo.
 *
 * Van en carga diferida y detrás de la comprobación de entorno para que ni
 * siquiera entren en el paquete de producción: son unos cuantos cientos de
 * kilobytes que allí no pinta nada.
 */
const Panel = lazy(async () => {
  const mod = await import("@tanstack/react-query-devtools");
  return { default: mod.ReactQueryDevtools };
});

export function QueryDevtools() {
  if (!import.meta.env.DEV) return null;

  return (
    <Suspense fallback={null}>
      {/* A la izquierda: la esquina de abajo a la derecha es de la ventana
          del chat de Work (§9.2), y dos botones flotantes en el mismo sitio
          se tapan el uno al otro. */}
      <Panel initialIsOpen={false} buttonPosition="bottom-left" />
    </Suspense>
  );
}
